import { put, takeEvery } from "redux-saga/effects"
import {
  GET_SOCIETY
} from "./actionTypes"

import {
  getSocietySuccess,
  getSocietyFail
} from "./actions"
import serviceSociety from '../../api/society.service';

function* fetchSociety() {
  const userAux = JSON.parse(sessionStorage.getItem('user'))
  try {
    const json = {
      userId: userAux.id.user.userId,
      systemCode: process.env.REACT_APP_SYSTEM_CODE,
    }
    const response = yield serviceSociety.getSociety(json)
    yield put(getSocietySuccess(response.data))
  } catch (error) {
    yield put(getSocietyFail(error))
  }
}

function* societySaga() {
  yield takeEvery(GET_SOCIETY, fetchSociety)

}

export default societySaga